<template>
	<div>
		<div class="content-header">
			<div class="content-header-tabs-wrap">
				<div class="content-header-tabs">
					<span
						v-for="(tab, tabIndex) in Object.keys(tabs)"
						:key="'tab' + tabIndex"
						:ref="'header-tab' + tabIndex"
						:class="[{ active: isCurrentTab(tab, tabs[tab]) }]"
						@click="changeTab(tab, tabs[tab])"
						v-html="names[tab].tab ? names[tab].tab : tab" />
				</div>
			</div>

			<div class="content-header-inner" v-if="pageTitle !== '' || pageDescription !== ''">
				<h1 class="content-header-title" v-if="pageTitle !== ''">{{ pageTitle }}</h1>

				<p v-if="pageDescription !== ''">{{ pageDescription }}</p>
			</div>
		</div>

		<span v-for="name in Object.keys(tabs)" :key="name">
			<slot :name="names[name].name ? names[name].name : name" v-if="isCurrentTab(name, tabs[name])" />
		</span>
	</div>
</template>

<script>
import { ref, computed, watch, getCurrentInstance } from "vue";

export default {
	name: "Tabbed",
	props: {
		names: {
			type: Object,
			default: () => ({}),
		},
		uriRoot: {
			type: String,
			default: "",
		},
	},
	setup(props) {
		const vm = getCurrentInstance().proxy;
		const currentTab = ref("home");
		const currentTab2 = ref("home");

		const tabs = computed(() => {
			let computedTabs = {};
			Object.keys(props.names).forEach((n) => {
				if (typeof props.names[n].hide === "undefined" || props.names[n].hide === false) {
					computedTabs[n] = { ...props.names[n] };
					if (!computedTabs[n].permalink) computedTabs[n].permalink = n.replace(" ", "-").toLowerCase();
					computedTabs[n].path = `${props.uriRoot}/${computedTabs[n].permalink}/`;
					if (computedTabs[n].append) computedTabs[n].path += `${computedTabs[n].append}/`;
					if (computedTabs[n].path.substr(0, 1) !== "/") computedTabs[n].path = `/${computedTabs[n].path}`;
				}
			});
			return computedTabs;
		});

		const pageTitle = computed(() => {
			if (currentTab2.value && tabs.value[currentTab2.value] && tabs.value[currentTab2.value].title) {
				return tabs.value[currentTab2.value].title;
			}
			return "";
		});

		const pageDescription = computed(() => {
			if (currentTab2.value && tabs.value[currentTab2.value] && tabs.value[currentTab2.value].description) {
				return tabs.value[currentTab2.value].description;
			}
			return "";
		});

		const isCurrentTab = (name, tabInfo) => {
			let tab = tabInfo.permalink ? tabInfo.permalink : name;
			return tab === currentTab.value;
		};

		const changeTab = (tab, tabInfo) => {
			currentTab2.value = tab;
			currentTab.value = tabInfo.permalink;
			if (vm.$route.path !== tabInfo.path) {
				vm.$router.push({ path: tabInfo.path });
			}
		};

		// Initial setup from created()
		const ops = vm.$route.path.split("/").filter((el) => el != null && el !== "");
		if (ops[0] === props.uriRoot && ops.length > 1) {
			Object.keys(tabs.value).forEach((tabKey) => {
				const tab = tabs.value[tabKey];
				if (tab.permalink === ops[1].toLowerCase()) {
					currentTab.value = tab.permalink;
					currentTab2.value = tabKey;
				}
			});
		}

		watch(
			() => vm.$route.path,
			(newPath, oldPath) => {
				if (newPath !== oldPath) { 
					Object.keys(tabs.value).forEach((tabKey) => {
						const tab = tabs.value[tabKey];
						if (tab.path === newPath) {
							// Only update the tab state, don't trigger router navigation
							currentTab2.value = tabKey;
							currentTab.value = tab.permalink;
						}
					});
				}
			}
		);

		return {
			currentTab,
			currentTab2,
			tabs,
			pageTitle,
			pageDescription,
			isCurrentTab,
			changeTab
		};
	},
	beforeRouteEnter(to, from, next) {
		next();
	},
};
</script>
